var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgDialogSuccessMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 403,
    viewBox: "0 0 333 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.32 41.6023C303.605 48.0892 381.178 3.97253 411.639 56.1383C443.952 111.475 385.951 184.856 373.167 251.314C365.266 292.394 409.904 415.852 393.203 454.116C376.775 491.757 309.338 441.598 278.961 467.157C247.265 493.828 211.327 510.387 173.21 521.677C126.279 535.577 8.64324 500.742 -37.6705 491.023C-84.7922 472.976 -36.8219 413.583 -53.7926 362.234C-64.41 330.109 -61.8392 323.274 -57.25 269.168C-52.3343 211.212 -75.0844 118.93 -44.0909 70.1711C-12.8532 21.0282 45.195 5.70815 94.2365 1.12984C154.174 -4.46572 197.69 36.0957 246.32 41.6023Z",
    fill: "#FFE64D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.32 41.6023C303.605 48.0892 381.178 3.97253 411.639 56.1383C443.952 111.475 385.951 184.856 373.167 251.314C365.266 292.394 409.904 415.852 393.203 454.116C376.775 491.757 309.338 441.598 278.961 467.157C247.265 493.828 211.327 510.387 173.21 521.677C126.279 535.577 8.64324 500.742 -37.6705 491.023C-84.7922 472.976 -36.8219 413.583 -53.7926 362.234C-64.41 330.109 -61.8392 323.274 -57.25 269.168C-52.3343 211.212 -75.0844 118.93 -44.0909 70.1711C-12.8532 21.0282 45.195 5.70815 94.2365 1.12984C154.174 -4.46572 197.69 36.0957 246.32 41.6023Z",
    fill: "url(#pattern0_22351_60933)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_22351_60933",
    patternContentUnits: "objectBoundingBox",
    width: 0.00912548,
    height: 0.00871143
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_22351_60933",
    transform: "scale(0.000570342 0.000544465)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_22351_60933",
    width: 16,
    height: 16,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAuSURBVHgB7ZKxDQAACMLE/39WL4DBxRi6QjoQUEMQMLA8Y4kFFwRQBfUTj/hC0AhaCBsbu2V8AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDialogSuccessMobile);
export default __webpack_public_path__ + "static/media/bg-dialog-success-mobile.034eae3ae91014a34cd01613baae1a9e.svg";
export { ForwardRef as ReactComponent };